// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PlaygroundChatAvatar-module__spinnerContainer__GrwlQdA"};